import { defineComponent } from 'vue';
import ImageAccordion from '@/components/ImageAccordion.vue';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'HomeQceit',
  components: {
    ImageAccordion: ImageAccordion
  },
  setup: function () {
    var imageList = [{
      id: '01',
      image: 'https://match-ide.pipacoding.com/cdn/test/image/dengjikaoshi-ycl-02.png?2021101301',
      // link: '/programming-test',
      link: ''
    }];
    function timeTransform() {
      var timestamp = new Date().getTime();
      var time = new Date(timestamp);
      var y = time.getFullYear();
      var M = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var m = time.getMinutes();
      var s = time.getSeconds();
      var tp = y + '-' + M + '-' + d + '-' + h + '-' + m + '-' + s;
      // var url = 'http://www.qceit.org.cn/bos/login.html?source_code=ht101&d=' + tp;
      var url = 'http://www.ycltest.com/?source_code=ht101&d=' + tp;
      return url;
    }
    var router = useRouter();
    var checkMore = function () {
      window.location.href = timeTransform();
    };
    var checkDetail = function () {
      router.push('/activity/2');
    };
    return {
      imageList: imageList,
      checkMore: checkMore,
      checkDetail: checkDetail
    };
  }
});